var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_146958",
    "data-name": "Group 146958",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.51,
    height: 15.515,
    viewBox: "0 0 15.51 15.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_50305",
    "data-name": "Path 50305",
    d: "M17.171,8.778,16.116,7.552a1.719,1.719,0,0,1-.365-.977V5.257a1.5,1.5,0,0,0-1.5-1.5H12.937a1.74,1.74,0,0,1-.977-.365L10.734,2.341a1.563,1.563,0,0,0-1.954,0L7.562,3.4a1.789,1.789,0,0,1-.977.357H5.243a1.5,1.5,0,0,0-1.5,1.5V6.583a1.765,1.765,0,0,1-.357.969L2.342,8.786a1.562,1.562,0,0,0,0,1.939l1.047,1.233a1.765,1.765,0,0,1,.357.969v1.326a1.5,1.5,0,0,0,1.5,1.5H6.585a1.74,1.74,0,0,1,.977.365L8.787,17.17a1.563,1.563,0,0,0,1.954,0l1.225-1.055a1.719,1.719,0,0,1,.977-.365h1.318a1.5,1.5,0,0,0,1.5-1.5V12.935a1.74,1.74,0,0,1,.365-.977l1.055-1.225a1.573,1.573,0,0,0-.008-1.954Zm-4.188-.489L9.237,12.035a.582.582,0,0,1-.822,0L6.538,10.158a.581.581,0,0,1,.822-.822L8.826,10.8l3.335-3.335a.581.581,0,0,1,.822.822Z",
    transform: "translate(-2.005 -1.998)",
    fill: "#284261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueVerified);
export default __webpack_public_path__ + "static/media/blue-verified.9577d1677b2e9d694ccbd5b5fe6a9d8d.svg";
export { ForwardRef as ReactComponent };